import { RouteConfig, Route, NavigationGuardNext } from "vue-router";
import webSalesOffersSettingService from '@/apps/shared/services/webSalesOffersSettings-service';
const homeWelcome = () => import("./quote/views/home.vue");
const plansSelection = () => import("./quote/views/plansSelection.vue");
const policyOwner = () => import("./quote/tabsClient/policyOwner.vue");
const personToCover = () => import("./quote/tabsClient/personToCover.vue");
const familyUpload = () => import("./quote/tabsClient/familyUpload.vue");
const declaracionJurada = () => import("./quote/tabsClient/declaracionJurada.vue");
const healtMaxSummary = () => import("./quote/tabsPayment/healtMaxSummary.vue");
const finalPayment = () => import("./quote/tabsPayment/finalPayment.vue");

const pageTitle = 'Cotizá tu seguro de Salud | Sancor Seguros';
const contentMetaData = 'Cotizá tu seguro de salud de manera rápida y sencilla. Compará precios y encontrá la cobertura que mejor se adapte a tus necesidades y presupuesto.'

const routes: Array<RouteConfig> = [
    {
        path: "/salud-segura-max/elegiPlan",
        name: "healthMaxPlansSelection-view",
        component: plansSelection,
        meta: {
            title: () => 'Elegí el Plan',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
    },
    {
        path: "/salud-segura-max/contratante",
        name: "healthMaxPolicyOwner-view",
        component: policyOwner,
        meta: {
            title: () => 'Datos del Tomador',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
    },
    {
        path: "/salud-segura-max/datosAsegurado",
        name: "healthMaxPersonToCover-view",
        component: personToCover,
        meta: {
            title: () => 'Datos del Asegurado',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
    },
    {
        path: "/salud-segura-max/datosFamiliar",
        name: "healthMaxFamilyUpload-view",
        component: familyUpload,
        meta: {
            title: () => 'Agregar Familiar Asegurado',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
    },
    {
        path: "/salud-segura-max/declaracionJurada",
        name: "declaracionJurada-view",
        component: declaracionJurada,
        meta: {
            title: () => 'Declaración Jurada',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
    },
    {
        path: "/salud-segura-max/resumen",
        name: "HealtMaxSummary",
        component: healtMaxSummary,
        meta: {
            title: () => 'Resumen',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },      
    },
    {
        path: "/salud-segura-max/finContrato",
        name: "healthMaxFinalPayment-view",
        component: finalPayment,
        meta: {
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
        beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
            const { ParamId, ExternalIdentifier, ChannelId } = to.query as {
                ParamId?: string;
                ExternalIdentifier?: string;
                ChannelId?: string;
            };

            // Si llega alguno de los tres parámetros, se guarda en sessionStorage
            if (ParamId || ExternalIdentifier || ChannelId) {
                if (ParamId) {
                    sessionStorage.setItem("ParamId", ParamId);
                }
                if (ExternalIdentifier) {
                    sessionStorage.setItem("PricingId", ExternalIdentifier);
                }
                if (ChannelId) {
                    sessionStorage.setItem("ChannelId", ChannelId);
                }

                sessionStorage.setItem("ExitOrContinueModal", "false");

                const timeStart = new Date();
                sessionStorage.setItem("TimeStartPaymentComplete", JSON.stringify(timeStart));

                // Redirigimos a la misma ruta SIN query para limpiarla
                next({ path: to.path, query: {} });
            } else {
                // Si no hay query params, seguimos normalmente
                next();
            }
        }
    },
    {
        path: "/salud-segura-max/elegiPlan/:subpath*",
        name: "healthMaxPlansSelection-view2",
        component: plansSelection,
        props: (route) => {
            return {
                offer: route.params.offer
            };
        },
        meta: {
            title: () => 'Elegi el Plan',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                }
            ]
        },
        beforeEnter: async (to: any, from: any, next: any): Promise<void> => {
            NF.UI.Page.block();
            try {
                const subpath = to.fullPath.split('/').pop();
                const actualPath = 'salud-segura-max/elegiPlan';
                const response = await webSalesOffersSettingService.getWebSalesOffersSettings(subpath, actualPath);
                if (response) {
                    to.params.offer = {
                        OffersSettings: response.pageCustomization
                    };
                    sessionStorage.setItem("rutaAlternativa", to.fullPath);
                    next();
                } else {
                    next({ name: 'not-found' });
                }
            }
            catch {
                next({ name: 'not-found' });
            } finally {
                NF.UI.Page.unblock();
            }
        },
    },
    // Ruta comodín debe ir al final siempre
    {
        path: "/salud-segura-max/:subpath*",
        name: "healthMaxHome-view",
        component: homeWelcome,
        meta: {
            title: () => 'Datos personales',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
        beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
            const { utm_source } = to.query as { utm_source?: string };

            const existente = sessionStorage.getItem("Referente");
            if (!existente) {
                if (utm_source) {
                    sessionStorage.setItem("Referente", utm_source);
                }
                else {
                    if (document.referrer != '') {
                        sessionStorage.setItem("Referente", document.referrer);
                    }
                    else {
                        sessionStorage.setItem("Referente", null);
                    }
                }
            }

            const { utm_medium } = to.query as { utm_medium?: string };

            const existente_medium = sessionStorage.getItem("Medium");
            if (!existente_medium) {
                if (utm_medium) {
                    sessionStorage.setItem("Medium", utm_medium);
                }
                else {
                    sessionStorage.setItem("Medium", 'organic');
                }
            }

            if (Object.keys(to.query).length > 0) {
                next({ path: to.path, query: {} });
            } else {
                next();
            }
        }
    },
];

export default routes;